// @ts-nocheck
import React from 'react';
import { Star, MapPin } from 'lucide-react';

export default function CompareDrawer({ videos, onClose }: { videos: any[]; onClose: ()=>void }) {
  if (!videos?.length) return null;
  return (
    <div className="fixed inset-0 z-[90]">
      <div className="absolute inset-0 bg-black/50" onClick={onClose}/>
      <div className="absolute bottom-0 left-0 right-0 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 rounded-t-2xl p-4 max-h-[80vh] overflow-auto">
        <div className="flex items-center justify-between mb-3">
          <div className="font-semibold text-sm">Compare {videos.length} places</div>
          <button onClick={onClose} className="px-2 py-1 text-sm rounded hover:bg-gray-100 dark:hover:bg-gray-800">Close</button>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
          {videos.map((v, i) => (
            <div key={v.id || i} className="rounded-xl border border-gray-200 dark:border-gray-800 p-3">
              <div className="font-medium truncate">{v.restaurant_name || v.title || 'Video'}</div>
              <div className="text-xs text-gray-500 truncate">{[v.restaurant_cuisine, v.restaurant_location].filter(Boolean).join(' • ')}</div>
              <div className="mt-2 flex items-center gap-3 text-sm">
                {v.restaurant_rating ? (
                  <span className="inline-flex items-center gap-1"><Star className="w-4 h-4 text-yellow-500" /> {Number(v.restaurant_rating).toFixed(1)}</span>
                ) : <span className="text-gray-400">No rating</span>}
                {v.distance_label ? (
                  <span className="inline-flex items-center gap-1"><MapPin className="w-4 h-4" /> {v.distance_label}</span>
                ) : null}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
